import { TournamentAwardDetailContainer } from './TournamentAwardDetailContainer.component';
import { connector } from './TournamentAwardDetailContainer.connector';

export default connector(TournamentAwardDetailContainer);
